import { render, staticRenderFns } from "./SendTelemedicine.vue?vue&type=template&id=1713ffd4&scoped=true&"
import script from "./SendTelemedicine.vue?vue&type=script&lang=js&"
export * from "./SendTelemedicine.vue?vue&type=script&lang=js&"
import style0 from "./SendTelemedicine.vue?vue&type=style&index=0&id=1713ffd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1713ffd4",
  null
  
)

export default component.exports